import dynamic from "next/dynamic";

export const DynamicContent022 = dynamic(() => import("./Content022"), {
  suspense: true,
});
